import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=logged out, object=user
  const [meta, setMeta] = useState({ statuses: [], roles: {} });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      try {
        const m = await api.get("/meta");
        setMeta(m.data);
      } catch (err) {
        console.error("Failed to load meta:", err);
      }
    } catch (err) {
      setUser(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback(async (email, password) => {
    await api.post("/auth/login", { email, password });
    await refresh();
  }, [refresh]);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (err) {
      console.error("Logout request failed:", err);
    }
    setUser(false);
  }, []);

  const can = useCallback((perm) => {
    if (!user || !user.permissions) return false;
    return user.permissions.includes("*") || user.permissions.includes(perm);
  }, [user]);

  const value = useMemo(
    () => ({ user, meta, login, logout, refresh, can }),
    [user, meta, login, logout, refresh, can]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}
